import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';
import LoginPage from '@/pages/LoginPage';
import AuthCallback from '@/pages/AuthCallback';
import SchemasPage from '@/pages/SchemasPage';
import SchemaDetailPage from '@/pages/SchemaDetailPage';
import SchemaImportPage from '@/pages/SchemaImportPage';
import AttributeDetailPage from '@/pages/AttributeDetailPage';
import ApplicabilityPage from '@/pages/ApplicabilityPage';
import EntitiesPage from '@/pages/EntitiesPage';
import EntityDocPage from '@/pages/EntityDocPage';
import ValuesetsPage from '@/pages/ValuesetsPage';
import ValuesetDetailPage from '@/pages/ValuesetDetailPage';
import AdminPage from '@/pages/AdminPage';
import SchemaGroupsPage from '@/pages/SchemaGroupsPage';
import ProposalsPage from '@/pages/ProposalsPage';
import CreateProposalPage from '@/pages/CreateProposalPage';
import EditProposalPage from '@/pages/EditProposalPage';
import PublicProposalPage from '@/pages/PublicProposalPage';
import ProtectedRoute from '@/components/ProtectedRoute';
import EntityChatDrawer from '@/components/EntityChatDrawer';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* New Dictionary Management */}
      <Route path="/" element={<ProtectedRoute><SchemasPage /></ProtectedRoute>} />
      <Route path="/schemas" element={<ProtectedRoute><SchemasPage /></ProtectedRoute>} />
      <Route path="/schemas/:schemaId" element={<ProtectedRoute><SchemaDetailPage /></ProtectedRoute>} />
      <Route path="/schemas/:schemaId/import" element={<ProtectedRoute><SchemaImportPage /></ProtectedRoute>} />
      <Route path="/attributes/:attributeId" element={<ProtectedRoute><AttributeDetailPage /></ProtectedRoute>} />
      <Route path="/attributes/:attributeId/applicability" element={<ProtectedRoute><ApplicabilityPage /></ProtectedRoute>} />
      <Route path="/entities" element={<ProtectedRoute><EntitiesPage /></ProtectedRoute>} />
      <Route path="/entities/:entityId/doc" element={<ProtectedRoute><EntityDocPage /></ProtectedRoute>} />
      <Route path="/valuesets" element={<ProtectedRoute><ValuesetsPage /></ProtectedRoute>} />
      <Route path="/valuesets/:valuesetId" element={<ProtectedRoute><ValuesetDetailPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
      <Route path="/schema-groups" element={<ProtectedRoute><SchemaGroupsPage /></ProtectedRoute>} />
      <Route path="/proposals" element={<ProtectedRoute><ProposalsPage /></ProtectedRoute>} />
      <Route path="/proposals/new" element={<ProtectedRoute><CreateProposalPage /></ProtectedRoute>} />
      <Route path="/proposals/:proposalId/edit" element={<ProtectedRoute><EditProposalPage /></ProtectedRoute>} />
      <Route path="/proposals/:proposalId" element={<ProtectedRoute><ProposalsPage /></ProtectedRoute>} />
      {/* Public (no auth) */}
      <Route path="/p/:shareToken" element={<PublicProposalPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
          <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

function AppContent() {
  const [entities, setEntities] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      api.get('/entities').then(r => setEntities(r.data)).catch(() => {});
    }
  }, [user]);

  return (
    <>
      <AppRouter />
      {user && <EntityChatDrawer entities={entities} />}
      <Toaster position="bottom-right" />
    </>
  );
}
